import CustomRadio from "./custom-radio.component";

export default CustomRadio;
